import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import compVideo from "./components/compVideo.vue";
import adPositionOptions from "../../components/serverList/adPositionOptions.vue";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import { getGameServerMap, getReasonMap, getGameGoodsMap } from "@/utils/dictionary";
export default {
  components: {
    serverList: serverList,
    compVideo: compVideo,
    adPositionOptions: adPositionOptions,
    timeDateOptions: timeDateOptions
  },
  name: "itemLog",
  data: function data() {
    return {
      goodsList: {},
      goodsArray: [],
      serverList: {},
      reasonList: {},
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        goods_id: ""
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameGoodsMap();
            case 2:
              _this.goodsList = _context.sent;
              for (index in _this.goodsList) {
                _this.goodsArray.push({
                  goodsId: index,
                  goodsName: _this.goodsList[index]
                });
              }
              _context.next = 6;
              return getGameServerMap();
            case 6:
              _this.serverList = _context.sent;
              _context.next = 9;
              return getReasonMap();
            case 9:
              _this.reasonList = _context.sent;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent(e) {
      this.searchInfo.sdate = this.timedata[0];
      this.searchInfo.edate = this.timedata[1];
      if (e == "search") {
        this.$refs.myChild.goMethod("1", this.searchInfo);
      } else {
        this.$refs.myChild.goMethod("2", this.searchInfo);
      }
    }
  }
};